// extracted by mini-css-extract-plugin
export default {"container":"StatsBox_container__k2mS7","title":"StatsBox_title__FoCiT","value":"StatsBox_value__iELQ-","small":"StatsBox_small__D09fG","medium":"StatsBox_medium__dwCuD"};